export const Permission = {
    // Society Permissions
    MANAGE_SOCIETY: 'manage_society',
    MANAGE_MEMBERS: 'manage_members',
    
    // Tournament Permissions
    CREATE_TOURNAMENT: 'create_tournament',
    CREATE_QUICK_ROUND: 'create_quick_round',
    EDIT_TOURNAMENT: 'edit_tournament',
    DELETE_TOURNAMENT: 'delete_tournament',
    
    // Player Permissions
    MANAGE_PLAYERS: 'manage_players',
    MANAGE_HANDICAPS: 'manage_handicaps',
    
    // Scoring Permissions
    ENTER_OWN_SCORE: 'enter_own_score',
    ENTER_GROUP_SCORE: 'enter_group_score',
    ENTER_ANY_SCORE: 'enter_any_score',
    FINALIZE_ROUND: 'finalize_round',
    
    // Insights Permissions
    VIEW_INSIGHTS: 'view_insights',
    
    // Betting Permissions
    MANAGE_ODDS: 'manage_odds',
    VIEW_BETS: 'view_bets',

    // Course Permissions
    MANAGE_COURSES: 'manage_courses',

    // Order of Merit Permissions
    MANAGE_OOM: 'manage_oom',

    // Advanced Tournament Engine Permissions
    MANAGE_COMPETITIONS: 'manage_competitions',
};